const supportName = "memocard_support";

export const links = {
  landing: "https://memocard.org",

  // Browser bot links
  appBrowser: "https://app.memocard.org",

  // Bot app links
  botApp: "https://t.me/memo_card_bot/app",

  botChannel: "https://t.me/memo_card_bot_channel",
  ruBotChannel: "https://t.me/memocard_ru",
  telegramRuVideosFirst: "https://t.me/memocard_ru/4",

  // Support
  supportChat: `https://t.me/${supportName}`,
  supportHandle: `@${supportName}`,
  supportEmail: "support@memocard.org",

  // YouTube
  youtubeChannelEn: "https://www.youtube.com/@MemoCardBot",
  youtubeChannelRu: "https://www.youtube.com/@MemoCardRu",

  // ToS and Privacy Policy
  privacyPolicyPath: "/privacy-policy.html",
  privacyPolicyRuPath: "/privacy-policy-ru.html",
  tosPath: "/terms-of-service.html",
  tosRuPath: "/terms-of-service-ru.html",
  privacyPolicy: "https://app.memocard.org/privacy-policy",
  termsOfService: "https://app.memocard.org/terms-of-service",

  appTelegram: "https://t.me/memo_card_bot?start=landing",
  github: "https://github.com/kubk/memo-card",
};
